// Copyright (c) 2016 Deere & Company

import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/ag-theme-balham.css';
import './report-grid.scss';
import { AgGridReact } from 'ag-grid-react';
import PropTypes from 'prop-types';
import React from 'react';

const ReportGrid = (props) => (
    <section className="report-grid ag-fresh">
        <AgGridReact
            enableColResize
            enableFilter
            enableSorting
            headerHeight={32}
            domLayout="autoHeight"
            rowHeight={32}
            {...props}
        />
    </section>
);

ReportGrid.displayName = 'ReportGrid';
ReportGrid.propTypes = {
    columnDefs: PropTypes.arrayOf(PropTypes.object).isRequired,
    onGridReady: PropTypes.func.isRequired,
    rowData: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ReportGrid;
